import { isPasswordValid } from '@/utils/validate-password';

// eslint-disable-next-line import/prefer-default-export
export function validateRequired() {
  if (this.userEdit.id && !this.userEdit.password && !this.userEdit.matchPassword) {
    return true;
  }
  return !!this.userEdit.password && !!this.userEdit.matchPassword;
}

export function validateMinLength(value) {
  if (this.userEdit.id && !this.userEdit.password) {
    return true;
  }
  return value !== null && value !== undefined && value.length >= 8;
}

export function validatePassword(value) {
  if (this.userEdit.id && !value) {
    return true;
  }
  return isPasswordValid(value);
}
